<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Reservorio</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="1400px">
        <template v-slot:activator="{ on }">
          <v-layout row wrap justify-end>
            <v-flex shrink>
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-on="on"
                @click="btnClicked('Andromeda')"
              >+ Nuevo Ingreso Andromeda</v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-on="on"
                @click="btnClicked('Aquila')"
              >+ Nuevo Ingreso Aquila</v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-on="on"
                @click="btnClicked('Argus')"
              >+ Nuevo Ingreso Argus</v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-on="on"
                @click="btnClicked('Aries')"
              >+ Nuevo Ingreso Aries</v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-on="on"
                @click="btnClicked('Aurora')"
              >+ Nuevo Ingreso Aurora</v-btn>
            </v-flex>
          </v-layout>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <template>
                <div>
                  <v-form v-model="valid">
                    <v-data-table
                      disable-initial-sort
                      :headers="headers2"
                      :items="items"
                      :pagination.sync="pagination"
                      class="elevation-2"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.nave }}</td>
                        <td>
                          <v-text-field v-model="props.item.nivel" label required></v-text-field>
                        </td>
                        <td>
                          <v-text-field v-model="props.item['CE Reservorio']" label required></v-text-field>
                        </td>
                        <td>
                          <v-text-field v-model="props.item['pH Reservorio']" label required></v-text-field>
                        </td>
                        <td class="justify-center">
                          <v-btn small color="green">
                            <v-icon color="white" @click="submitItem(props)">check</v-icon>
                          </v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-form>
                </div>
              </template>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
            <!-- <v-btn color="blue darken-1" flat @click="save">Guardar</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      disable-initial-sort
      :headers="headers"
      :items="entry"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ props.item.nave }}</td>
        <td class="text-xs-right">{{ props.item.nivel }}</td>
        <td class="text-xs-right">{{ props.item['CE Reservorio'] }}</td>
        <td class="text-xs-right">{{ props.item['pH Reservorio'] }}</td>
        <td class="text-xs-right">{{ new Date(props.item.createdAt).toLocaleString() }}</td>
        <td class="justify-center layout px-0">
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data: () => ({
    Andromeda: [
      {
        nave: "Andromeda",
        sector: ""
      }
    ],
    Aquila: [
      {
        nave: "Aquila",
        sector: ""
      }
    ],
    Argus: [
      {
        nave: "Argus",
        sector: ""
      }
    ],
    Aries: [
      {
        nave: "Aries",
        sector: ""
      }
    ],
    Aurora: [
      {
        nave: "Aurora",
        sector: ""
      }
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 25,
      totalItems: 0
    },
    dialog: false,
    headers: [
      {
        text: "Nave",
        align: "left",
        sortable: false,
        value: "nave"
      },
      { text: "% Nivel del reservorio", value: "nivel", align: "right" },
      { text: "CE Reservorio", value: "CE Reservorio", align: "right" },
      { text: "pH Reservorio", value: "pH Reservorio", align: "right" },
      { text: "Fecha", value: "date", align: "right" },
      { text: "Eliminar", value: "name", sortable: false, align: "center" }
    ],
    headers2: [
      {
        text: "Nave",
        align: "left",
        sortable: false,
        value: "nave"
      },
      { text: "% Nivel del reservorio", value: "nivel" },
      { text: "CE Reservorio", value: "CE Reservorio" },
      { text: "pH Reservorio", value: "pH Reservorio" },
      { text: "Aceptar", value: "name", sortable: false }
    ],
    entry: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {}
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Ingreso" : "Edit Item";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    this.new();
  },
  methods: {
    new() {
      this.editedItem.date = `${new Date().getDate()}/${new Date().getMonth()}/${new Date().getFullYear()}`;

      this.$axios
        .get("/api/ReservoirReports/", this.editedItem)
        .then(response => {
          console.log("resp", response);
          this.entry = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    btnClicked(e) {
      console.log(e);
      this.items = this[`${e}`];
    },
    deleteItem(item) {
      const index = this.entry.indexOf(item);
      const _id = {
        _id: this.entry[this.entry.indexOf(item)]._id
      };
      confirm("¿Estas seguro que quieres eliminar este registro?");
      let r = confirm("¿Estas seguro que quieres eliminar este registro?");
      if (r == true) {
        this.entry.splice(index, 1);
        this.$axios.post("/api/DeleteReservoirReports/", _id);
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    submitItem(props) {
      console.log(props.item);
      console.log(props.index);

      this.$axios
        .post("/api/ReservoirReports/", props.item)
        // .then(response => {
        //   if( response.status === 200) {
        //     console.log("responsessss", response)
        //     this.items.splice(props.index, 1);
        //     alert("Registro enviado!!!")
        //     this.new()
        //   }
        .then(response => {
          if (response.status === 200) {
            this.items = this.items.filter(function(obj) {
              return obj.nave !== props.item.nave;
              // console.log(this.items)
            });
            alert("Registro enviado!!!");
            this.new();
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>

<style scoped>
.v-card {
  padding: 30px !important;
}
</style>
